import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import {
  ACCESS_MAP_NOTES,
  DESIGNATION_ACCESS_MAP,
  ROLE_ACCESS_MAP,
} from '../../utils/crmAccessMap';
import './TeamAccessMap.css';

const TeamAccessMap: React.FC = () => {
  return (
    <div className="team-access-page">
      <Link to="/people/team" className="team-access-back">
        <ArrowLeft size={14} aria-hidden />
        Team
      </Link>
      <h1 className="team-access-title">Role access</h1>
      <p className="team-access-lead">
        What each CRM role sees in the header, Settings, and the notification bell.
        Designations add extras on Employee — Full or admin accounts — they do not create a
        separate header.
      </p>

      <nav className="team-access-jump" aria-label="Jump to role">
        {ROLE_ACCESS_MAP.map(role => (
          <a
            key={role.id}
            href={`#access-${role.id}`}
            style={{ '--jump-color': role.color, '--jump-bg': role.bg } as React.CSSProperties}
            onClick={event => {
              event.preventDefault();
              document.getElementById(`access-${role.id}`)?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }}
          >
            {role.label}
          </a>
        ))}
      </nav>

      {ROLE_ACCESS_MAP.map(role => (
        <article
          key={role.id}
          id={`access-${role.id}`}
          className="team-access-card"
          style={{ '--role-color': role.color } as React.CSSProperties}
        >
          <header className="team-access-card-head">
            <h2 className="team-access-role">{role.label}</h2>
            <span className="team-access-home">{role.home}</span>
          </header>
          <div className="team-access-grid">
            <div className="team-access-col">
              <h3>Header</h3>
              <ul>
                {role.header.map(item => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            {role.people && (
              <div className="team-access-col">
                <h3>{role.people.label}</h3>
                <ul>
                  {role.people.items.map(item => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
            <div className="team-access-col">
              <h3>Avatar menu</h3>
              <ul>
                {role.avatar.map(item => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="team-access-col">
              <h3>Settings</h3>
              <ul>
                {role.settings.map(item => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="team-access-col team-access-col-notifications">
              <h3>Notifications</h3>
              <ul>
                {role.notifications.map(item => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            {role.notes && role.notes.length > 0 && (
              <div className="team-access-notes">
                <strong>Also</strong>
                <ul>
                  {role.notes.map(item => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </article>
      ))}

      <h2 className="team-access-section-title">Designations</h2>
      <p className="team-access-section-lead">
        These sit on an employee or admin account and add money, People, or contractor access.
      </p>
      {DESIGNATION_ACCESS_MAP.map(row => (
        <article key={row.id} className="team-access-desig">
          <h3>{row.label}</h3>
          <span className="team-access-desig-meta">{row.appliesTo}</span>
          <ul>
            {row.extras.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
      ))}

      <h2 className="team-access-section-title">Worth knowing</h2>
      {ACCESS_MAP_NOTES.map(note => (
        <article key={note.title} className="team-access-callout">
          <h3>{note.title}</h3>
          <p>{note.body}</p>
        </article>
      ))}
    </div>
  );
};

export default TeamAccessMap;
